import type { FC } from "react";

import classNames from "classnames";

import { SocialFacebookIcon } from "@jti/brand-icons/social-facebook";
import { SocialFacebookMessengerIcon } from "@jti/brand-icons/social-facebook-messenger";
import { SocialImessageIcon } from "@jti/brand-icons/social-imessage";
import { SocialInstagramIcon } from "@jti/brand-icons/social-instagram";
import { SocialLineIcon } from "@jti/brand-icons/social-line";
import { SocialMailIcon } from "@jti/brand-icons/social-mail";
import { SocialSnapchatIcon } from "@jti/brand-icons/social-snapchat";
import { SocialTelegramIcon } from "@jti/brand-icons/social-telegram";
import { SocialViberIcon } from "@jti/brand-icons/social-viber";
import { SocialWhatsappIcon } from "@jti/brand-icons/social-whatsapp";
import { SocialXIcon } from "@jti/brand-icons/social-x";
import { SocialYoutubeIcon } from "@jti/brand-icons/social-youtube";

import type { SocialSharingIconsProps } from "./SocialSharingIcons.builder";

import styles from "./SocialSharingIcons.module.scss";

const socialIcons = {
  "social-facebook": SocialFacebookIcon,
  "social-facebook-messenger": SocialFacebookMessengerIcon,
  "social-line": SocialLineIcon,
  "social-telegram": SocialTelegramIcon,
  "social-instagram": SocialInstagramIcon,
  "social-snapchat": SocialSnapchatIcon,
  "social-mail": SocialMailIcon,
  "social-x": SocialXIcon,
  "social-viber": SocialViberIcon,
  "social-whatsapp": SocialWhatsappIcon,
  "social-youtube": SocialYoutubeIcon,
  "social-imessage": SocialImessageIcon,
} as const;

export const SocialSharingIcons: FC<SocialSharingIconsProps> = ({ alignment, items = [] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        ...(styles.start ? { [styles.start]: alignment === "start" } : {}),
        ...(styles.center ? { [styles.center]: alignment === "center" } : {}),
        ...(styles.end ? { [styles.end]: alignment === "end" } : {}),
      })}
    >
      {items.map((item, index) => {
        const Icon = socialIcons[item.icon];

        if (item.url) {
          return (
            <a key={index} href={item.url} target="_blank" rel="noopener noreferrer" className={styles.link}>
              <Icon className={styles.icon} />
            </a>
          );
        }

        return <Icon className={styles.icon} key={index} />;
      })}
    </div>
  );
};
